import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DateModule, UtcDatePipe } from '@epicuro-next/ataraxia/date';
import { FormatPricePipe } from '@epicuro-next/ataraxia/formatting';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { LoaderOverlayModule } from '@epicuro-next/ataraxia/loader-overlay';
import { PopoverModule } from '@epicuro-next/ataraxia/popover';
import { TooltipDirective } from '@epicuro-next/ataraxia/tooltip';
import { EngagementCommonModule } from '@epicuro-next/features/engagement/engagement-common';
import { ListsModule } from '@epicuro-next/features/lists/lists-common';
import { DocumentControlStateModule } from '@epicuro-next/state/document-control-state';
import { LetDirective, PushPipe } from '@ngrx/component';

import { ListCallToActionButtonComponent } from './list-call-to-action-button/list-call-to-action-button.component';
import { ShopTheCommercialListComponent } from './shop-the-commercial-list/shop-the-commercial-list.component';

const publicComponents = [
  ListCallToActionButtonComponent,
  ShopTheCommercialListComponent,
];

@NgModule({
  imports: [
    CommonModule,
    ListsModule,
    LetDirective,
    PushPipe,
    PopoverModule,
    LoaderOverlayModule,
    DateModule,
    IconsModule,
    TooltipDirective,
    EngagementCommonModule,
    DocumentControlStateModule,
    FormatPricePipe,
  ],
  declarations: [...publicComponents],
  providers: [UtcDatePipe],
  exports: publicComponents,
})
export class ListCallToActionModule {}
